<template>
  <DomesticIndex />
</template>

<script setup lang="ts">
definePageMeta({
  layout: 'center'
})

useHead({
  title: '가이드'
})
</script>
